module.exports = __webpack_public_path__ + "img/instagram-brands.9cfc5ec3.svg";